import styled from "styled-components";

const Container = styled.div`
    position: fixed;
    top: 0px;
    width: 100%;
    max-width: 500px;
    height: calc(100% - 0px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`

export {
    Container
}